<template>
    <div>
        <div v-if="($page.props.acl.isAdmin && pack.migrator)" class="grid grid-cols-3 gap-2 my-1 bg-gray-100 p-1">
            <div class="col-span-1 text-left pl-2">
                <strong>Colis transféré par:</strong> {{ pack.migrator.name }}
            </div>
            <div class="col-span-2 text-left pl-2">
                <strong>Motif du transfert:</strong> {{ pack.migrate_reason }}
            </div>
        </div>
        <div class="w-full my-2 bg-gray-100 p-2">
            <div class="relative timeline_package">
                <div class="absolute left-0 top-1/2 -mt-px w-full h-0.5 bg-gray-300" aria-hidden="true"></div>
                <ul class="relative flex justify-between w-full">
                    <li class="flex" v-for="(history, index) in pack.historical" :key="index">
                        <div class="w-5 h-5 rounded-full border-2"
                            :class="history.pass ? 'bg-'+history.status_color+'-500 border-'+history.status_color+'-700' : 'bg-white border-gray-300'"
                        >
                            <span class="sr-only">1</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="w-full flex justify-between text-xs font-semibold text-gray-700 italic my-2 uppercase">
                <div class="text-center" v-for="(history, index) in pack.historical" :key="index">
                    <span class="block font-bold text-sm" :class="history.pass ? 'text-'+history.status_color+'-700' : 'text-gray-400'">
                        {{ history.name }}
                    </span>
                    <span class="block italic font-semibold text-small text-gray-400">{{ history.pass ? history.date : 'Bientôt' }}</span>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <div class="flex flex-col col-span-full sm:col-span-5 xl:col-span-3 space-y-2">
                <button v-if="pack.acl_list.canAddImage" @click.prevent="manageFilesModal = true"
                    class="shadow-lg btn hover:bg-sky-400 bg-sky text-white py-1 px-2 uppercase"
                >
                    <i class="fad fa-camera"></i><span class="ml-2">Ajouter des images</span>
                </button>
                <button v-else
                    class="shadow-lg btn bg-gray-300 text-gray-600 py-1 px-2 uppercase cursor-not-allowed opacity-80"
                    title="Ajout d’images indisponible (droits insuffisants ou expédition clôturée)"
                    disabled
                >
                    <i class="fad fa-camera"></i><span class="ml-2">Ajouter des images</span>
                </button>
                <button @click.prevent="viewFilesModal = true"
                    class="shadow-lg btn hover:bg-greendack-400 bg-greendack-500 text-white py-1 px-2 uppercase"
                >
                    <i class="fad fa-images"></i><span class="ml-2">Voir les images du colis</span>
                </button>
                <div v-if="pack.acl_list.canBeTake || pack.acl_list.canBeVoid || pack.acl_list.canBeUnpaid || pack.acl_list.canBeAbandoned"
                    class="grid grid-cols-2 gap-2"
                >
                    <button v-if="pack.acl_list.canBeTake" @click.prevent="takePackage"
                        class="col-span-1 btn bg-greendack-100 text-greendack-500 hover:bg-greendack-500 hover:text-greendack-100 py-0 px-1"
                    >
                        <i class="fas fa-check text-xs"></i>
                        <span class="text-small ml-1">RECUPERER</span>
                    </button>

                    <button v-if="pack.acl_list.canBeVoid" @click.prevent="voidPackage"
                        class="col-span-1 btn bg-violet-100 text-violet-500 hover:bg-violet-500 hover:text-white py-0 px-1"
                    >
                        <i class="fas fa-ban text-xs"></i>
                        <span class="text-small ml-1">VOID</span>
                    </button>

                    <button v-if="pack.acl_list.canBeUnpaid" @click.prevent="unpaidPackage"
                        class="col-span-1 btn bg-red-100 text-red-500 hover:bg-red-500 hover:text-white py-0 px-1"
                    >
                        <i class="fas fa-money-bill-wave text-xs"></i>
                        <span class="text-small ml-1">NON-PAYÉ</span>
                    </button>

                    <button v-if="pack.acl_list.canBeAbandoned" @click.prevent="abandonedPackage"
                        class="col-span-1 btn bg-gray-100 text-gray-500 hover:bg-gray-500 hover:text-white py-0 px-1"
                    >
                        <i class="fas fa-box-open text-xs"></i>
                        <span class="text-small ml-1">ABANDONNER</span>
                    </button>
                </div>
                <div class="shadow-lg rounded-sm border border-gray-200">
                    <h2 class="flex justify-between bg-gray-100 text-gray-800 font-semibold px-2 py-1 text-left border-b border-gray-200">
                        Description
                        <button v-if="pack.acl_list.canBeCollect" @click.prevent="collectPackage"
                            class="btn hover:bg-orange-100 hover:text-orange-700 bg-orange-700 text-orange-100 py-0 px-1"
                        >
                            <svg class="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z" clip-rule="evenodd" />
                            </svg>
                            <span class="text-small ml-1">COLLECTER</span>
                        </button>
                        <button v-if="pack.acl_list.canBeEmbbeded" @click.prevent="embeddedPackage"
                            class="btn bg-yellow-100 text-yellow-700 hover:bg-yellow-700 hover:text-yellow-100 py-0 px-1"
                        >
                            <svg class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                            </svg>
                            <span class="text-small ml-1">EMBARQUER</span>
                        </button>
                        <button v-if="pack.acl_list.canBeAvailable" @click.prevent="availablePackage"
                            class="btn bg-marron-100 text-marron-700 hover:bg-marron-700 hover:text-marron-100 py-0 px-1"
                        >
                            <svg class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                            </svg>
                            <span class="text-small ml-1">DISPONIBLE</span>
                        </button>
                    </h2>
                    <table class="details-pack-table w-full" style="table-layout:fixed">
                        <tbody>
                            <tr>
                                <td style="padding:0!important;text-align:left">
                                    <textarea class="details-pack" cols="24" rows="3" style="border:none;font-size:0.87rem" disabled :value="pack.description ?? 'Non renseigné'"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="pack.weight" class="shadow-lg rounded-sm border border-gray-200">
                    <h2 class="flex justify-between bg-gray-100 text-gray-800 font-semibold px-2 py-1 text-left border-b border-gray-200">
                        Nombre de colis: {{ pack.weight }}
                    </h2>
                </div>
                <div v-if="pack.address" class="shadow-lg rounded-sm border border-gray-200">
                    <h2 class="flex justify-between bg-gray-100 text-gray-800 font-semibold px-2 py-1 text-left border-b border-gray-200">
                        Adresse de récupération
                    </h2>
                    <table class="details-pack-table" style="table-layout:fixed;width:100%">
                        <tbody>
                            <tr>
                                <td style="padding:0!important;text-align:left">
                                    <textarea class="details-pack" cols="24" rows="4" style="border:none;font-size:0.87rem" disabled :value="pack.address"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-span-full sm:col-span-7 xl:col-span-9 shadow-lg rounded-sm border border-gray-200">
                <div>
                    <h2 class="flex justify-between bg-gray-200 text-gray-800 font-semibold px-2 py-1 text-left">
                        <span>Informations de facturation: <span class="text-sky">N°{{ pack.invoice.reference }}</span></span>

                        <div class="flex items-center justify-end space-x-2">
                            <StatusBadge :label="pack.invoice.status_text" :color="pack.invoice.status_color" />
                            <button @click.prevent="printInvoice" class="btn bg-greendack-500 text-white hover:bg-greendack-400 py-0 px-1">
                                <svg class="h-4 w-4 fill-current shrink-0" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </h2>
                    <div class="p-2 border border-gray-200 rounded-sm shadow-sm">
                        <div class="sm:flex sm:justify-between sm:flex-wrap gap-2">
                            <div class="grow text-left font-semibold text-gray-500">
                                Montant: {{ formatAmount(pack.amount, currency) }}
                                <span v-if="Number(pack.discount_percent) > 0" class="text-xs text-red-500">
                                    − Remise {{ pack.discount_percent }}%
                                    ({{ formatAmount(pack.discount_amount, currency) }})
                                </span>
                            </div>
                            <div class="grow text-left font-semibold text-gray-500">
                                Total facture: {{ formatAmount(pack.invoice.amount, currency) }}
                                <span v-if="pack.invoice.penalties.length">
                                    + Pénalités: {{ formatAmount(pack.invoice.total_penalties, currency) }}
                                    = {{ formatAmount(pack.invoice.amount_with_penalties, currency) }}
                                </span>
                            </div>
                            <div class="grow text-left font-semibold text-gray-500">
                                <div>Total versé: {{ formatAmount(pack.invoice.total_paid, currency) }}</div>
                            </div>
                            <div class="grow text-left font-semibold text-gray-500">
                                <div>Total restant: {{ formatAmount(pack.invoice.balance, currency) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="pack.invoice.penalties.length" >
                    <h2 class="flex justify-between bg-red-500 text-white font-semibold px-2 py-1 text-left">
                        <span>Informations relatives aux pénalités</span>
                    </h2>
                    <div class="p-2 border border-gray-200 rounded-sm shadow-sm">
                        <div class="sm:flex sm:justify-between">
                            <div class="grow text-left font-semibold text-red">
                                <div class="inline-flex">
                                    Pénalité: {{ pack.invoice.penalties.length }}
                                    jour{{ pack.invoice.penalties.length > 1 ? 's' : '' }}
                                </div>
                            </div>
                            <div class="grow text-left font-semibold text-red">
                                <div class="inline-flex ">
                                    Montant pénalité: {{ formatAmount(pack.invoice.total_penalties, currency) }}
                                </div>
                            </div>
                            <div class="grow text-left font-semibold text-red">
                                <div class="inline-flex font-bold">
                                    Total final à verser: {{ formatAmount(pack.invoice.amount_with_penalties, currency) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <h2 class="flex justify-between bg-gray-200 text-gray-800 font-semibold px-2 py-1 text-left">
                        Historique des paiements
                        <template v-if="pack.invoice.balance > 0">
                            <button v-if="pack.acl_list.canAddPayment" class="btn bg-sky text-white hover:bg-sky-400 p-1" @click.prevent="showModal">
                                <svg class="h-3 w-3 fill-current shrink-0" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
                                </svg>
                            </button>
                            <button v-if="pack.acl_list.canAddPaymentOperator" class="btn bg-sky text-white hover:bg-sky-400 p-1" @click.prevent="showModal">
                                <svg class="h-3 w-3 fill-current shrink-0" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </template>
                    </h2>
                    <div class="overflow-x-auto">
                        <table class="w-full">
                            <thead class="text-xs font-semibold uppercase text-gray-500 bg-gray-50 border-t border-b border-gray-200">
                                <tr>
                                    <th>Référence</th>
                                    <th>Montant</th>
                                    <th>Mode de paiement</th>
                                    <th>Date</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody class="text-xs divide-y divide-gray-200">
                                <template v-if="!pack.invoice.payments.length">
                                    <tr>
                                        <td colspan="5">
                                            <div class="text-center text-2xl text-red-400 bg-red-100 p-10">
                                                Aucun paiement enregistré pour le moment.
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else v-for="(payment, index) in pack.invoice.payments" :key="index">
                                    <tr>
                                        <td>
                                            <span class="text-sky font-semibold">{{ payment.reference }}</span>
                                        </td>
                                        <td>
                                            <div class="text-right">{{ formatAmount(payment.amount, currency) }}</div>
                                        </td>
                                        <td>{{ payment.mode_real_text }}</td>
                                        <td class="capitalize">{{ formattedDate(payment.created_at) }}</td>
                                        <td class="text-right">
                                            <i @click.prevent="printPayment(payment)"
                                                class="fad fa-print text-sm cursor-pointer text-greendack-500 hover:text-greendack-400"
                                            ></i>
                                            <button v-if="pack.acl_list.canDeletePayment && payment.id === pack.lastPaymentId"
                                                class="text-red-500 hover:text-red-600 ml-3 disabled:opacity-50" @click.prevent="destroyPayment(payment)"
                                            ><i class="fad fa-trash text-sm"></i>
                                            </button>
                                            <i v-else title="Impossible de supprimer"
                                                class="fad fa-trash text-sm text-gray-500 opacity-50 cursor-not-allowed ml-3"
                                            ></i>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="($page.props.acl.isAdmin && pack.is_taked)" class="w-full mt-1 bg-greendack-100 py-1 px-3 rounded-sm shadow-lg">
            <h2 class="text-gray-500 font-semibold text-center animate-pulse text-lg">
                Récupération effectuée par: <span class="font-bold text-greendack-500">{{ pack.operator.name }}</span>
            </h2>
        </div>
    </div>

    <JetDialogModal :show="manageModal" @close="closeModal" max-width="2xl">
        <template #title>Ajouter un paiement au colis N°{{ pack.code }}</template>

        <template #content>
            <div class="grid grid-cols-2 gap-4">
                <div class="col-span-1 sm:col-span-1">
                    <JetLabel for="amount">
                        Montant du versement (<a href="#" @click="form.amount = pack.invoice.balance" class="underline text-sky-600">Solder</a>)(<span class="text-red-500 text-sm">*</span>):
                    </JetLabel>
                    <JetInput id="amount" type="number" min="0" placeholder="O"
                        class="text-right" v-model="form.amount" />
                    <JetInputError :message="form.errors.amount" />
                </div>
                <div class="col-span-1 sm:col-span-1">
                    <JetLabelRequired for="code" value="Mode de paiement" />
                    <select v-model="form.mode" class="form-input w-full uppercase">
                        <option value="null" disabled selected hidden>Choisissez le mode de paiement</option>
                        <option v-for="(mode, index) in modes" :key="index" :value="mode['value']">
                            {{ mode['description'] }}
                        </option>
                    </select>
                    <JetInputError :message="form.errors.mode" />
                </div>
            </div>
        </template>

        <template #footer>
            <BotiButton @click="closeModal" text="Quitter" color="red">
                <template #icon><i class="fad fa-times-circle text-xs ml-1"></i></template>
            </BotiButton>

            <BotiButton :loader="form.processing" :disabled="form.processing"
                @click="storePayment" text="Enregistrer"
                class="ml-2" :class="{ 'opacity-25': form.processing }"
            >
                <svg v-if="form.processing" class="animate-spin w-4 h-4 fill-current shrink-0" viewBox="0 0 16 16">
                    <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"></path>
                </svg>
                <template #icon>
                    <i class="fad fa-check-circle text-xs ml-1"></i>
                </template>
            </BotiButton>
        </template>
    </JetDialogModal>

    <JetDialogModal :show="manageFilesModal" @close="manageFilesModal = false" max-width="xl">
        <template #title>Ajouter des images au colis N°{{ pack.code }}</template>

        <template #content>
            <div class="grid grid-cols-2 gap-4">
                <div class="col-span-full">
                    <UploadFilesBox
                        :route="route('travels.packages.upload-files', { travel: travel.reference, package: pack.code })"
                        :media="pack.media"
                    />
                </div>
            </div>
        </template>

        <template #footer>
            <BotiButton @click.prevent="manageFilesModal = false" text="Quitter" color="red">
                <template #icon><i class="fad fa-times-circle text-xs ml-1"></i></template>
            </BotiButton>
        </template>
    </JetDialogModal>

    <JetDialogModal :show="viewFilesModal" @close="viewFilesModal = false" max-width="xl">
        <template #title>Les images du colis N°{{ pack.code }}</template>

        <template #content>
                <div v-if="pack.media.length">
                    <div class="grid grid-cols-3 gap-4">
                        <div v-for="(media, index) in pack.media" :key="index" class="w-full h-48 rounded-sm overflow-hidden">
                            <img :src="media.original_url" alt="" class="w-full h-full object-cover">
                        </div>
                    </div>
                </div>
                <div v-else class="col-span-full text-center text-gray-500 italic">
                    Aucune image pour ce colis
                </div>
        </template>

        <template #footer>
            <BotiButton @click.prevent="viewFilesModal = false" text="Quitter" color="red">
                <template #icon><i class="fad fa-times-circle text-xs ml-1"></i></template>
            </BotiButton>
        </template>
    </JetDialogModal>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetLabel from '@/Jetstream/Label'
    import JetInput from '@/Jetstream/Input'
    import useDevice from '@/composables/device'
    import BotiButton from '@/Components/Button'
    import StatusBadge from '@/Components/StatusBadge'
    import JetInputError from '@/Jetstream/InputError'
    import PrintMixins from '@/Mixins/PrintMixins.vue'
    import CurrencyMixins from '@/Mixins/CurrencyMixins'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import UploadFilesBox from '@/Components/UploadFilesBox'
    import DateFormatMixins from '@/Mixins/DateFormatMixins'
    import JetLabelRequired from '@/Jetstream/LabelRequired'
    import FormValidatorErrorMixinsVue from '@/Mixins/FormValidatorErrorMixins.vue'

    export default defineComponent({
        components: {
            JetLabel,
            JetInput,
            BotiButton,
            StatusBadge,
            JetInputError,
            JetDialogModal,
            UploadFilesBox,
            JetLabelRequired
        },

        props: {
            pack: Object,
            modes: Array,
            travel: Object,
            currency: Object
        },

        setup() {
            const { isMobile, isTablet, isDesktop } = useDevice()

            return {
                isMobile,
                isTablet,
                isDesktop
            }
        },

        mixins: [PrintMixins, FormValidatorErrorMixinsVue, CurrencyMixins, DateFormatMixins],

        data () {
            return {
                manageModal: false,
                manageFilesModal: false,
                viewFilesModal: false,
                form: this.$inertia.form({
                    mode: null,
                    amount: null
                }),
            }
        },

        methods: {
            closeModal() {
                this.manageModal = false
                this.form.clearErrors()
                this.form.reset()
            },

            showModal() {
                this.form.clearErrors()
                this.manageModal = true
            },

            storePayment() {
                this.form.post(route('invoices.payments.store', this.pack.invoice), {
                    preserveScroll: true,
                    onSuccess: () =>{
                        this.closeModal()
                        this.$swal.fire(
                            'Paiement',
                            'Paiement ajouté avec succès.',
                            'success'
                        )
                    },
                })
            },

            printInvoice() {
                const url = route('invoices.print', this.pack.invoice)

                if (this.isMobile || this.isTablet) {
                    // 📱 MOBILE → PREVIEW
                    const link = document.createElement('a')
                    link.href = url
                    // link.target = '_blank'
                    link.click()
                } else {
                    // 💻 DESKTOP → NEW TAB
                    this.print(url)
                }
            },

            printPayment(payment) {
                const url = route('invoices.payments.print', {
                    invoice: this.pack.invoice,
                    payment: payment
                })

                if (this.isMobile || this.isTablet) {
                    // 📱 MOBILE → PREVIEW
                    const link = document.createElement('a')
                    link.href = url
                    // link.target = '_blank'
                    link.click()
                } else {
                    // 💻 DESKTOP → NEW TAB
                    this.print(url)
                }
            },

            printPackage() {
                const url = route('travels.packages.print', {
                    travel: this.travel,
                    package: this.pack
                })

                if (this.isMobile || this.isTablet) {
                    // 📱 MOBILE → PREVIEW
                    const link = document.createElement('a')
                    link.href = url
                    // link.target = '_blank'
                    link.click()
                } else {
                    // 💻 DESKTOP → NEW TAB
                    this.print(url)
                }
            },

            collectPackage() {
                this.$swal.queue([{
                    title: "Colis",
                    text: "Êtes vous sûr de vouloir marquer le colis comme collecté ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#f97316',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Collecter",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.form.post(route('travels.packages.collect', {
                            travel: this.travel,
                            package: this.pack
                        }), {
                            preserveScroll: true,
                            onSuccess: () =>{
                                this.closeModal()
                                this.$swal.fire(
                                    'Colis',
                                    'Colis collecté avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.insertQueueStep({
                                    icon: 'error',
                                    title: 'Oups! Impossible de marquer le colis comme collecté.'
                                })
                            }
                        })
                    }
                }])
            },

            embeddedPackage() {
                this.$swal.queue([{
                    title: "Colis",
                    text: "Êtes vous sûr de vouloir marquer le colis comme embarqué ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#eab308',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Embarquer",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.form.post(route('travels.packages.embedded', {
                            travel: this.travel,
                            package: this.pack
                        }), {
                            preserveScroll: true,
                            onSuccess: () =>{
                                this.closeModal()
                                this.$swal.fire(
                                    'Colis',
                                    'Colis embarqué avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.insertQueueStep({
                                    icon: 'error',
                                    title: 'Oups! Impossible de marquer le colis comme embarqué.'
                                })
                            }
                        })
                    }
                }])
            },

            availablePackage() {
                this.$swal.queue([{
                    title: "Colis",
                    text: "Êtes vous sûr de vouloir rendre le colis disponible ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#966641',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Disponible",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.form.post(route('travels.packages.available', {
                            travel: this.travel,
                            package: this.pack
                        }), {
                            preserveScroll: true,
                            onSuccess: () =>{
                                this.closeModal()
                                this.$swal.fire(
                                    'Colis',
                                    'Colis maintenant disponible.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.insertQueueStep({
                                    icon: 'error',
                                    title: 'Oups! Impossible de rendre le colis disponible.'
                                })
                            }
                        })
                    }
                }])
            },

            takePackage() {
                this.$swal.queue([{
                    title: "Colis",
                    text: "Êtes vous sûr de vouloir lancer la procédure de récupération du colis ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#0d9488',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Récupérer",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.form.post(route('travels.packages.take', {
                            travel: this.travel,
                            package: this.pack
                        }), {
                            preserveScroll: true,
                            onSuccess: () =>{
                                this.closeModal()
                                this.$swal.fire(
                                    'Colis',
                                    'Colis récupéré avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                if (error.amount) {
                                    this.$swal.fire({
                                        icon: 'error',
                                        title: error.amount,
                                    })
                                } else {
                                    this.$swal.fire({
                                        icon: 'error',
                                        title: 'Oups! Impossible de lancer la procédure de récupération du colis.',
                                    })
                                }
                            }
                        })
                    }
                }])
            },

            voidPackage() {
                this.$swal.queue([{
                    title: "Colis",
                    text: "La personne n’a rien payé. Êtes vous sûr de vouloir void ce colis ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#5A4AA3',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Void",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.form.post(route('travels.packages.void', {
                            travel: this.travel,
                            package: this.pack
                        }), {
                            preserveScroll: true,
                            onSuccess: () =>{
                                this.closeModal()
                                this.$swal.fire(
                                    'Colis',
                                    'Colis void avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: 'Oups! Impossible de void du colis.',
                                })
                            }
                        })
                    }
                }])
            },

            unpaidPackage() {
                this.$swal.queue([{
                    title: "Colis",
                    text: "La personne a payé partiellement. Êtes vous sûr de vouloir marquer ce colis comme non payé ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#bd081c',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Marquer non payé",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.form.post(route('travels.packages.unpaid', {
                            travel: this.travel,
                            package: this.pack
                        }), {
                            preserveScroll: true,
                            onSuccess: () =>{
                                this.closeModal()
                                this.$swal.fire(
                                    'Colis',
                                    'Colis marqué non payé avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: 'Oups! Impossible de marquer le colis comme non payé.',
                                })
                            }
                        })
                    }
                }])
            },

            abandonedPackage() {
                this.$swal.queue([{
                    title: "Colis",
                    text: "Êtes vous sûr de vouloir marquer ce colis comme abandonné ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#64748b',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Marquer abandonné",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.form.post(route('travels.packages.abandoned', {
                            travel: this.travel,
                            package: this.pack
                        }), {
                            preserveScroll: true,
                            onSuccess: () =>{
                                this.closeModal()
                                this.$swal.fire(
                                    'Colis',
                                    'Colis marqué abandonné avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: 'Oups! Impossible de marquer le colis comme abandonné.',
                                })
                            }
                        })
                    }
                }])
            },

            destroyPayment(payment) {
                this.$swal.queue([{
                    title: "Paiement",
                    text: "Êtes vous sûr de vouloir supprimer le paiement ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: 'rgb(241, 162, 0)',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Supprimer",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.$inertia.delete(route('invoices.payments.destroy', {
                            invoice: this.pack.invoice,
                            payment: payment
                        }), {
                            preserveScroll: true,
                            preserveState: true,
                            onSuccess: () => {
                                this.$swal.fire({
                                    icon: 'success',
                                    title: "Paiement",
                                    text: "Paiement supprimé avec succès.",
                                })
                            },
                            onError: (error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: error.message || 'Oups! Impossible de supprimer le paiement.',
                                })
                            }
                        })
                    }
                }])
            }
        }
    })
</script>

<style scoped>
    tbody :deep(tr:hover td) {
        background-color: rgba(225, 225, 225, 1)!important
    }
    .details-pack-table tbody :deep(tr td) {
        background-color: rgb(226, 232, 240, 1) !important
    }
    .details-pack-table tbody :deep(tr:hover td) {
        background-color: rgb(226, 232, 240, 1) !important
    }
    .details-pack {
        background-color: rgb(226, 232, 240, 1) !important;
        color: #333333;
        width: 100%;
    }
    .details-pack:hover {
        background-color: rgb(226, 232, 240, 1) !important
    }
</style>
